import { ApiProperty } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { IsEnum, IsNumber, IsUUID } from 'class-validator';
import { ContractorAllocatedCapacityInterface } from '../interfaces/contractor-allocated-capacity.interface';
import { ContractorResourceTypeEnum } from '../../contractor/enums/contractor-resource-type.enum';

@Exclude()
export class ContractorAllocatedCapacityDto
  implements ContractorAllocatedCapacityInterface
{
  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Contractor ID',
    description: 'The contractor this allocation summary belongs to',
  })
  @IsUUID()
  @Expose()
  contractorId!: string;

  @ApiProperty({
    title: 'Resource Type',
    description: 'The resource type being allocated',
    enum: ContractorResourceTypeEnum,
  })
  @IsEnum(ContractorResourceTypeEnum)
  @Expose()
  resourceType!: ContractorResourceTypeEnum;

  @ApiProperty({
    title: 'Total Allocated',
    description:
      'The total amount currently allocated for this contractor and resource type',
  })
  @IsNumber()
  @Expose()
  totalAllocated!: number;
}
